import { z } from "zod";

// t("IN_CLINIC")
// t("HOME_VISIT")
export const appointmentLocationEnum = z.enum(["IN_CLINIC", "HOME_VISIT"]);

export type AppointmentLocation = z.infer<typeof appointmentLocationEnum>;
